import request from '@/utils/request'

// 首页数据
export function getHomeData (params) {
  return request({
    url: 'api/z/h/home/data',
    method: 'get',
    params
  })
}

// 获取轮播图
export function getBannerList (params) {
  return request({
    url: '/api/z/ad/getAdList',
    method: 'post',
    params
  })
}
// 历史搜索记录
export function getHistorySerarch (params) {
  return request({
    url: 'pmsSearchWord/historySerarch',
    method: 'get',
    params
  })
}
// 大家都在搜_H5
export function getHotSearchList (params) {
  return request({
    url: 'api/z/search/getListByType',
    method: 'get',
    params
  })
}
// 清空用户搜索记录
export function deleteSearchRecords (params) {
  return request({
    url: 'pmsSearchWord/deleteSearchByMemberId',
    method: 'get',
    params
  })
}
// 搜索页-推荐品牌
export function getRecommendBrands (params) {
  return request({
    url: 'api/z/h/home/recommend/product',
    method: 'get',
    params
  })
}
// 搜索页-推荐店铺
export function getRecommendShops (params) {
  return request({
    url: 'api/z/h/home/recommend/shop',
    method: 'get',
    params
  })
}

// 点击广告
export function clickAdvert (params) {
  return request({
    url: '/api/z/ad/addAdShowNum',
    method: 'post',
    params
  })
}

// 根据分类id获取文章列表
export function getLeverlArticleList (params) {
  return request({
    url: '/api/z/articleList',
    method: 'get',
    params
  })
}
// 获取文章分类根据上级id
export function getListByParentId (params) {
  return request({
    url: '/api/z/article/getListByParentId',
    method: 'get',
    params
  })
}
// 文章点赞
export function getLikeArticle (params) {
  return request({
    url: 'article/like',
    method: 'put',
    params
  })
}
// 获取文章详情
export function getArticleDetail (params) {
  return request({
    url: 'article/detail',
    method: 'get',
    params
  })
}
// 获取新闻资讯栏目列表
export function getNewsList (params) {
  return request({
    url: '/api/z/article/getNewsList',
    method: 'get',
    params
  })
}
// 获取jssdk签名
export function getJssdkToken (params) {
  return request({
    url: '/api/z/jssdk/getJssdkToken',
    method: 'get',
    params
  })
}
// 获取jssdk签名
export function getPayJssdkToken (params) {
  return request({
    url: '/api/z/jssdk/getPayJssdkToken',
    method: 'get',
    params
  })
}

// 获取配置数据
export function configData (params) {
  return request({
    url: '/api/z/sys/dict/list/key',
    method: 'get',
    params
  })
}

// 首页十宫格图标显示
export function homeHfiveTag (params) {
  return request({
    url: '/api/z/home/hfiveTag',
    method: 'get',
    params
  })
}

// 分享文章店铺商品
export function sharePage (params) {
  return request({
    url: '/api/z/sharePage/sharePage',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js